import React, { useState } from 'react';
import './StarLeaderBoardTopInt.css';
export default function StarLeaderBoardTopInt({ data, info }) {
	const [showInfow, setShowInfo] = useState(false);
	return (
		<div className='star-cont'>
			<div className="starLeaderboardInt">
				<div className='starLeaderboardContainer'>
					<div>
						<img src='https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/birscndddd.svg' 
							// className="starLeaderboardInt__ranklogo2"
							className='starLeaderboard1'
						/>
						<img src={data[1]?.orgLogo} className="starLeaderboardInt__rank2" />
						<div className="starLeaderboardInt__institue2">{data[1]?.orgName}</div>
					</div>

					<div>
						<img src='https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/crwn.svg'
							className="starLeaderboardInt__crown"
						/>
					</div>

					<div>
						<img src='https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/birfirsttt.svg' 
							className="starLeaderboardInt__yellow" 
						/>
						<img src={data[0]?.orgLogo} className="starLeaderboardInt__rank1"/>
						<div className="starLeaderboardInt__institue1">{data[0]?.orgName}</div>
					</div>

					<div>
						<img src='https://ali-cdn-cp-assets-public.classplus.co/campaigns-assets/birthirddd.svg' 
							// className="starLeaderboardInt__ranklogo3" 
							className='starLeaderboard2'
						/>
						<img src={data[2]?.orgLogo} className="starLeaderboardInt__rank3" />
						<div className="starLeaderboardInt__institue3">{data[2]?.orgName}</div>
					</div>
				</div>

				{showInfow && <div className="starLeaderboardInt__infoText">{info}</div>}
			</div>
		</div>
	);
}
